import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { getCookie } from "~/helpers/cookies";

const appInsightsTelemetry = new ReactPlugin();
const connectionString =
  import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING;
const environment = process.env.NODE_ENV;

let appInsights = null;

const TRACK_METHOD = Object.freeze({
  METRIC: "metric",
  PAGE_VIEW: "page-view",
  EVENT: "event",
  EXCEPTION: "exception",
  TRACE: "trace",
});

const EVENT = Object.freeze({
  SHOW_REDIRECTING_INFO: "ShowRedirectingInfo"
});

const trackMethods = new Map([
  [TRACK_METHOD.METRIC, (telemetryObject) => appInsightsTelemetry.trackMetric(telemetryObject)],
  [TRACK_METHOD.PAGE_VIEW, (telemetryObject) => appInsightsTelemetry.trackPageView(telemetryObject)],
  [TRACK_METHOD.EVENT, (telemetryObject) => appInsightsTelemetry.trackEvent(telemetryObject)],
  [TRACK_METHOD.EXCEPTION, (telemetryObject) => appInsightsTelemetry.trackException(telemetryObject)],
  [TRACK_METHOD.TRACE, (telemetryObject) => appInsightsTelemetry.trackTrace(telemetryObject)],
]);

const cookies = Object.freeze({
  user: "ai_user",
  session: "ai_session",
});

if (connectionString) {
  try {
    appInsights = new ApplicationInsights({
      config: {
        connectionString: connectionString,
        extensions: [appInsightsTelemetry],
        enableUnhandledPromiseRejectionTracking: true,
        enableAutoRouteTracking: true,
      },
    });

    appInsights.loadAppInsights();
  } catch (error) {
    console.error("Failed to initialize Application Insights", error);
  }
} else {
  if (environment && environment === "production") {
    console.warn(
      "Application Insights connection string not found. Skipping initialization."
    );
  }
}

const trackAppInsightsTelemetry = (telemetryObject, method) => {
  if (appInsightsTelemetry?.isInitialized()) {
    const trackMethod = trackMethods.has(method)
      ? trackMethods.get(method)
      : trackMethods.get(TRACK_METHOD.TRACE);

    trackMethod(telemetryObject);

    return;
  }

  console.log("AppInsightsTelemetryObject", telemetryObject);
};

const getAppInsightsCookies = () => {
  const userId = getCookie(cookies.user) ?? "N/A";
  const sessionId = getCookie(cookies.session) ?? "N/A";

  return {
    userId,
    sessionId,
  };
};

export {
  trackAppInsightsTelemetry,
  getAppInsightsCookies,
  TRACK_METHOD,
  EVENT,
};
